import React from 'react';

type TileProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  footer: string;
};

const Tile = ({ icon, title, description, onClick, footer }: TileProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className="
        bg-white
        p-4
        rounded-lg
        shadow-md
        cursor-pointer
        flex
        flex-col
        h-full
        transition-all
        duration-200
        ease-in-out
        hover:shadow-xl
        hover:-translate-y-1
        active:translate-y-0
        active:scale-[0.98]
        active:shadow-sm
        focus-visible:outline
        focus-visible:outline-2
        focus-visible:outline-offset-2
        focus-visible:outline-blue-600
      "
    >
      <div className="mb-3 text-green-700 mb-4">{icon}</div>

      <h2 className="text-lg font-bold text-black mt-0 mb-2 leading-snug">{title}</h2>

      <p className="text-sm text-gray-600 leading-relaxed">{description}</p>

      <div className="text-sm text-green-600 leading-relaxed mt-auto pt-4 font-bold text-left inline-flex items-center gap-2">
        <span>{footer}</span>
        <svg
          className="relative top-[2px]"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </div>
    </div>
  );
};

export default Tile;